import api from "./api";
// @ts-expect-error - api is not typed
const { post } = api.getPrefixedMethods("files");
export const filesService = {
    getPresignedUrl: (fileName) => {
        return post("get-presigned-url/", { fileName });
    },
    verifyUpload: (downloadUrl) => {
        return post("verify-upload/", { downloadUrl });
    },
    // LAM-3580: TIFF uploads go through this endpoint; the backend converts
    // the TIFF to a PDF with PyMuPDF before storing it in S3. PDFs continue
    // to use the faster presigned direct-to-S3 path via getPresignedUrl.
    // _skipPropsAdaptation bypasses the humps decamelizeKeys/camelizeKeys
    // interceptors on both request and response — required so FormData is not
    // destroyed on the way out, and we manually map the snake_case response.
    // We intentionally do NOT pass a filename override to FormData.append —
    // the browser will use file.name, and the backend generates its own UUID
    // prefix for the S3 key (avoids the double-UUID effect of passing the
    // caller-constructed uploadKey through as the filename).
    convertAndUpload: async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await post("convert-and-upload/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            _skipPropsAdaptation: true,
            timeout: 120000,
        });
        return {
            downloadUrl: response.download_url,
            uploadKey: response.upload_key,
        };
    },
};
